import styled from '@emotion/styled';
import { tokens, Alert, Button, Checkbox, Field, Link } from '@hotjar/hotsauce';

const FORM_WIDTH = '500px';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100vh;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  border-top: 1px solid ${tokens.color.ui_border_light};
`;

export const FormWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 1;
  width: 100%;
  padding: ${tokens.spacer.x5} ${tokens.spacer.x2};

  @media ${tokens.breakpoint.minWidth.m} {
    width: 50%;
    flex-shrink: 0;
  }
  @media ${tokens.breakpoint.minWidth.l} {
    width: ${FORM_WIDTH};
    flex-grow: 0;
  }
`;

export const SideWrapper = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 1;

  @media ${tokens.breakpoint.minWidth.m} {
    display: flex;
  }
`;

export const Form = styled.form`
  width: 100%;
  max-width: 360px;
`;

export const Title = styled.h1`
  ${tokens.text('header4')};
  margin-bottom: ${tokens.spacer.x2};
  text-shadow: none;
  overflow: initial;
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: ${tokens.spacer.x6};
`;

export const SubTitle = styled.h2`
  ${tokens.text('body2')};
  color: ${tokens.color.text_light};

  margin-bottom: ${tokens.spacer.x6};
`;

export const StyledLink = styled(Link)`
  ${tokens.text('body2')}
  color: ${tokens.color.cobalt_800}
`;

export const StyledButton = styled(Button)`
  width: 100%;
  justify-content: center;
`;

export const StyledField = styled(Field)`
  width: 100%;
  margin-bottom: ${tokens.spacer.x3};
  label {
    text-transform: initial;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-bottom: ${tokens.spacer.x3};
  margin-top: ${tokens.spacer.x1};
  text-transform: initial;
`;

export const KeepSignedInLabel = styled.span`
  display: inline-block;
  margin-left: ${tokens.spacer.x1};
`;

export const StyledForgotPasswordLink = styled(Link)`
  display: inline-block;
  ${tokens.text('caption')};
  margin-bottom: ${tokens.spacer.x2};
`;
